export default "__VITE_ASSET__ZCIiAaBo__"